import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';

import { Button, DropdownButton } from '../../../components';
import { Tel } from './components';
import { short } from '../common/formatting/date';

const PatientADTModal = ({
	isOpen,
	onClose,
	patientADTs = [],
	currentAdt = {},
	onShowCCDA,
}) => {
	let patientDob = 'NOT AVAILABLE';
	if (!isEmpty(currentAdt.patient_dob)) {
		[patientDob] = currentAdt.patient_dob.split('T');
		patientDob = short(patientDob, false, 'PP');
	}
	return (
		<Modal
			isOpen={isOpen}
			contentLabel="Care Team"
			className="modal-dialog patient-adts-modal modal-lg"
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">Patient ADTs</h3>
					</div>
				</div>
				<div className="modal-body">
					<div>
						<strong>
							{currentAdt.patient_first_name} {currentAdt.patient_last_name}{' '}
							{currentAdt.patient_gender && `(${currentAdt.patient_gender})`}
						</strong>
						<br />
						<Tel telString={currentAdt.patient_phone} />
						<br />
						DOB: {patientDob}
						<br />
						<address>
							{currentAdt.patient_address}
							<br />
							{currentAdt.patient_city}, {currentAdt.patient_state}
						</address>
					</div>
					<div className="table-responsive">
						<table className="table table-striped">
							<tbody>
								{patientADTs.map((adt) => (
									<tr
										key={`${adt.id}`}
										className={cn({ selected: adt.id === currentAdt.id })}
									>
										<td>{!adt.adt_date ? '<NO DATE>' : short(adt.adt_date)}</td>
										<td>
											{!adt.adt_date
												? '<NO TIME>'
												: short(adt.adt_date, false, 'p')}
										</td>
										<td>
											{adt.adt_message_type_text}
											{!adt.patient_class_description
												? ''
												: ` - ${adt.patient_class_description}`}
										</td>
										<td>{adt.disposition_description}</td>
										<td>{adt.sending_facility}</td>
										<td className="ccda-button-container">
											{Boolean(adt.ccda_available_ind) && (
												<DropdownButton
													title="CCDA"
													primary
													containerClassName="ccda-dropdown"
													right
													items={[
														{
															title: 'Full CCDA',
															onClick: () => onShowCCDA(adt.id),
														},
														{
															title: 'Summary CCDA',
															onClick: () => onShowCCDA(adt.id, false),
														},
													]}
												/>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
				<div className="modal-footer">
					<div className="pull-right">
						<Button title="OK" onClick={onClose} large primary className="ml" />
					</div>
				</div>
			</div>
		</Modal>
	);
};

PatientADTModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	patientADTs: PropTypes.array,
	currentAdt: PropTypes.object,
	onShowCCDA: PropTypes.func,
};

export default PatientADTModal;
